import './app.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  useMsal,
  useMsalAuthentication,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionType } from '@azure/msal-browser';

import Layout from './components/templates/layout/layout';
import Dashboard from './pages/dashboard/dashboard';
import Forecast from './pages/forecast/forecast';
import Profile from './pages/profile/profile';
import NoPageFound from './pages/noPageFound/noPageFound';
import { RecoilRoot } from 'recoil';
import { useEffect, useState } from 'react';
import PastForecast from './pages/forecast/pastForecast/pastForecast';
import UnAuthorizedPage from './pages/unAuthorized/unAuthorizedPage';
import { getAccessToken } from './services/authServices';
import SpinnerLoader from './components/atoms/SpinnerLoader';
import LogOutScreen from './components/organisms/headerComponent/logOutScreen';

function App() {
  useMsalAuthentication(InteractionType.Redirect);
  const [userEmailId, setUserEmailId] = useState('');
  const [azureAccessToken, setAzureAccessToken] = useState('');

  const [isLoading, setIsLoading] = useState(true);

  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {
    const accessTokenRequest = {
      scopes: ['user.read'],
      account: accounts[0],
    };
    instance
      .acquireTokenSilent(accessTokenRequest)
      .then(accessTokenResponse => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        setAzureAccessToken(accessToken);
        sessionStorage.setItem('azureToken', accessToken);
      })
      .catch(error => {
        if (error instanceof InteractionRequiredAuthError) {
          instance
            .acquireTokenPopup(accessTokenRequest)
            .then(function (accessTokenResponse) {
              // Acquire token interactive success
              let accessToken = accessTokenResponse.accessToken;
              setAzureAccessToken(accessToken);
              sessionStorage.setItem('azureToken', accessToken);
            })
            .catch(function (error) {
              // Acquire token interactive failure
              console.log(error);
            });
        }
      });
  }, [instance, accounts, inProgress]);

  if (userEmailId == '' && azureAccessToken != '') {
    try {
      let userLoginEmail = accounts[0].username;
      let userAzureLocalId = accounts[0].localAccountId;

      setUserEmailId(userLoginEmail);

      localStorage.setItem('userEmail', userLoginEmail.toLowerCase());

      // When logout functionality implemented, only then we will able to delete 'authDetails'
      getAccessToken(userLoginEmail.toLowerCase(), azureAccessToken)
        .then(result => {
          sessionStorage.setItem('authDetails', JSON.stringify(result));
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setIsLoading(false);
        });
    } catch (e) {
      console.log('error', e);
    }
  }

  return (
    <RecoilRoot>
      <BrowserRouter>
        {accounts ? (
          <>
            {isLoading ? (
              <div style={{ position: 'fixed', top: '50%', left: '50%' }}>
                <SpinnerLoader color="#155CB4" />
              </div>
            ) : (
              <AuthenticatedTemplate>
                <Routes>
                  <Route path="/" element={<Layout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="forecast" element={<Forecast />} />
                    <Route path="forecast/past" element={<PastForecast />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="*" element={<NoPageFound />} />
                  </Route>
                  <Route path="/logout" element={<LogOutScreen />} />
                </Routes>
              </AuthenticatedTemplate>
            )}
          </>
        ) : (
          <UnauthenticatedTemplate>
            <Routes>
              <Route path="/" element={<UnAuthorizedPage />}>
                <Route path="*" element={<NoPageFound />} />
              </Route>
            </Routes>
          </UnauthenticatedTemplate>
        )}
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default App;
